import { render, staticRenderFns } from "./PrivacyCollection.vue?vue&type=template&id=374da24c&scoped=true"
import script from "./PrivacyCollection.vue?vue&type=script&lang=js"
export * from "./PrivacyCollection.vue?vue&type=script&lang=js"
import style0 from "./PrivacyCollection.vue?vue&type=style&index=0&id=374da24c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374da24c",
  null
  
)

export default component.exports